import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useDemoAccount } from '@/hooks/useDemoAccount';

/**
 * Persistent trial strip for self-serve demo accounts.
 * Renders nothing for real accounts.
 */
export function DemoModeBanner() {
  const { isDemo, daysRemaining, expired, loading } = useDemoAccount();

  // Demo trial strip hidden for now (preview mode = unlimited, no countdown).
  // Remove this early return to bring the banner back.
  return null;

  if (loading || !isDemo) return null;

  const label = expired
    ? 'Your demo has ended'
    : daysRemaining === null
      ? 'Demo workspace'
      : daysRemaining <= 1
        ? 'Last day of your demo'
        : `${daysRemaining} days left in your demo`;

  return (
    <div className="sticky top-0 z-50 w-full border-b border-primary/25 bg-primary/10 backdrop-blur-sm">
      <div className="container mx-auto flex items-center justify-between gap-3 px-4 py-2">
        <div className="flex items-center gap-2 text-sm font-medium text-foreground">
          <Sparkles className="h-4 w-4 shrink-0 text-primary" />
          <span>{label}</span>
          <span className="hidden text-muted-foreground sm:inline">
            · Students, classes and scores here are sample data
          </span>
        </div>
        <Button
          size="sm"
          className="h-7"
          onClick={() => window.open('https://calendly.com/bigesales/demo', '_blank', 'noopener')}
        >
          Talk to us
        </Button>
      </div>
    </div>
  );
}

export default DemoModeBanner;
